/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect } from "react";
import { useMediaQuery } from "@mui/material";
import { useAppDispatch } from "hooks";
import {
	Body,
	Container,
	Title,
	Step,
	StepTitle,
	StepDescription,
	StepImage,
	StepInfo,
	StepsContainer,
	StepImageWrapper
} from "./styles";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import CloseIconButton from "components/AppModalDialogsV2/Dialogs/lib/CloseIconButton";
import { onClosePopUp } from "redux/slices";
import { pwaAssets } from "assets/cdn";
import { isIOS } from "react-device-detect";
import usePopUpsV2 from "components/PopUpManagerV2/hooks/usePopUpsV2";
import { useGoogleAnalyticsContext } from "contexts/GoogleAnalyticsProvider";
import { useImagePath } from "hooks/useImagePath";

interface PWAInfoPopupProps {}

export const PWAInfoPopup: React.FC<PWAInfoPopupProps> = () => {
	const { getImage } = useImagePath("cdn");
	const isPortrait = useMediaQuery("(orientation: portrait)");
	const { close } = usePopUpsV2();
	const { reportPlaygamiEvent } = useGoogleAnalyticsContext();

	const scale = useCalculateScale(
		isPortrait ? 363 + 40 : 956 + 40,
		isPortrait ? 613 + 40 : 410 + 40
	);

	const dispatch = useAppDispatch();
	const step1ImageAndroid = getImage(pwaAssets.infoStep1Android);
	const step2ImageAndroid = getImage(pwaAssets.infoStep2Android);
	const step1ImageiOS = getImage(pwaAssets.infoStep1Ios);
	const step2ImageiOS = getImage(pwaAssets.infoStep2Ios);
	const step3Image = getImage(pwaAssets.infoStep3);

	useEffect(() => {
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "pwa_install_instruction_dialog_shown",
			event_type: "pwa_install",
			action: "instruction_dialog_shown",
			source: "pwa_install"
		});
	}, [reportPlaygamiEvent]);

	const onClose = () => {
		//dispatch(onClosePopUp());
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "pwa_install_instruction_dialog_closed",
			event_type: "pwa_install",
			action: "instruction_dialog_closed",
			source: "pwa_install"
		});
		close({ variant: "pwa-info-popup" });
	};

	const steps = [
		{
			id: 1,
			title: "Step 1:",
			description: (
				<>
					Tap the <strong>“Share”</strong> button in your browser.
				</>
			),
			getImageSrc: () => (isIOS ? step1ImageiOS : step1ImageAndroid)
		},
		{
			id: 2,
			title: "Step 2:",
			description: (
				<>
					Click <strong>“Add to Home Screen”</strong> button and then{" "}
					<strong>“Add”</strong>.
				</>
			),
			getImageSrc: () => (isIOS ? step2ImageiOS : step2ImageAndroid)
		},
		{
			id: 3,
			title: "Step 3:",
			description: <>Enjoy your daily benefits through your shortcut!</>,
			getImageSrc: () => step3Image
		}
	];

	return (
		<Container scale={scale} backgroundImage={""}>
			<CloseIconButton onClose={onClose} />
			<Body>
				<Title>
					<div>Web Shop SHORTCUT</div>
				</Title>
				<StepsContainer>
					{steps.map((step) => {
						const imageSrc = step.getImageSrc();
						return (
							<Step key={step.id}>
								<StepInfo>
									<StepTitle>{step.title}</StepTitle>
									{!isPortrait && (
										<StepImageWrapper>
											<StepImage src={imageSrc} alt={`Step ${step.id}`} />
										</StepImageWrapper>
									)}
									<StepDescription>{step.description}</StepDescription>
								</StepInfo>
								{isPortrait && (
									<StepImageWrapper>
										<StepImage src={imageSrc} alt={`Step ${step.id}`} />
									</StepImageWrapper>
								)}
							</Step>
						);
					})}
				</StepsContainer>
			</Body>
		</Container>
	);
};
